import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import Footer from './components/Footer/Footer';
import Dashboard from './components/Dashboard/Dashboard';
import ShipMaintenanceTable from './components/ShipMaintenanceTable/ShipMaintenanceTable';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
          <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
          <div className="flex">
            <Sidebar isOpen={isSidebarOpen} />
            <main className="flex-1 p-6 overflow-auto">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/maintenance" element={
                  <div className="space-y-6">
                    <div>
                      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                        Ship Maintenance Predictions
                      </h1>
                      <p className="text-gray-600 dark:text-gray-400">
                        View and manage all scheduled maintenance activities
                      </p>
                    </div>
                    <ShipMaintenanceTable />
                  </div>
                } />
              </Routes>
            </main>
          </div>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;